
// images
// shoulders
import TightShoulders from 'assets/images/body-morphology/tight-shoulders.png';
import WideShoulders from 'assets/images/body-morphology/wide-shoulders.png';

// chest
import SmallChest from 'assets/images/body-morphology/Small-chest.png';
import LargeChest from 'assets/images/body-morphology/Large-chest.png';
import MediumChest from 'assets/images/body-morphology/Average-chest.png';

// waist
import SmallWaist from 'assets/images/body-morphology/small-waist.png';
import RoundedWaist from 'assets/images/body-morphology/round-waist.png';
import StraightWaist from 'assets/images/body-morphology/straight-waist.png';

const shoulders_images = [
    { img: TightShoulders, alt: 'TightShoulders', value: 'tight' },
    { img: WideShoulders, alt: 'WideShoulders', value: 'wide' }
];
const chest_images = [
    { img: SmallChest, alt: 'SmallChest', value: 'small' },
    { img: MediumChest, alt: 'MediumChest', value: 'medium' },
    { img: LargeChest, alt: 'LargeChest', value: 'large' }
];
const waist_images = [
    { img: SmallWaist, alt: 'SmallWaist', value: 'small' },
    { img: RoundedWaist, alt: 'RoundedWaist', value: 'rounded' },
    { img: StraightWaist, alt: 'StraightWaist', value: 'straight' }
];

const BodyShapeImages = ({ customer }) => {
    const { shoulders, waist, chest } = customer?.body_shape;

    if (!shoulders) {
        return null;
    }

    return (
        <div className="column is-4">
            <img
                src={(shoulders_images.find((i) => i.value === shoulders)).img} alt={shoulders} />
            <img
                src={(chest_images.find((i) => i.value === chest)).img} alt={chest} />
            <img
                src={(waist_images.find((i) => i.value === waist)).img} alt={waist} />
        </div>
    )
}

export { BodyShapeImages };
